import React from 'react';
import axios from 'axios';
import Breadcrumb from  '../../../components/Layout/Breadcrumb';
import SystemEmailTips from './SystemEmailTips';
import { connect } from 'react-redux';
import { MdEmail, MdCreate } from 'react-icons/md';
import { Link } from 'react-router-dom'
import { Spinner, Button } from 'react-bootstrap';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import {
	Row,
	Col,
	Card,
	CardBody,
	Form,
	FormGroup,
	Input,
	Label,
	Alert
} from 'reactstrap';

class SystemEmailDetailComponent extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			isLoading: true,
			error: false,
			messageError: '',
			isNotification: false,
			textNotification: '',
			isSpinner: false,
			emailId: 0,
			title: '',
			subject: '',
			content: '',
			service: '',
			service_type: [],
		}
	}

	componentDidMount() {
		window.scrollTo(0, 0);
		this.systemEmailDetail(this.props.emailId);
		this.setState({
			isNotification: this.props.isNotification,
			textNotification: this.props.textNotification,
		})
		if ( this.props.isNotification ) {
			this.props.notification({
				isNotification: false,
				textNotification: ''
			});
		}
	}

	systemEmailDetail = (emailId) => {
		this.setState({
			isLoading: true
		});
		let dataAuth = {
			username: process.env.REACT_APP_CLIENT_ID,
			password: process.env.REACT_APP_CLIENT_PASSWD,
			token: process.env.REACT_APP_KEY,
		};

		let config = {
		  	headers: {
				'Content-Type': 'application/json',
				'Authorization' : this.props.token,
				'dataAgency' : JSON.stringify(dataAuth)
			},
		  	params: { id: emailId }
		}

		axios.get( process.env.REACT_APP_API_URL + '/api/admin/email/system-email/edit-form', config)
		.then( (ref) => {
			// console.log(ref.data);
			if ( ref.data.error === 0 ) {
				this.setState({
					title: ref.data.content.email.title,
					subject: ref.data.content.email.subject,
					content: ref.data.content.email.content,
                    service: ref.data.content.email.service,
                    service_type: ref.data.content.service_type,
                    id: ref.data.content.email.id,
					isLoading: false,
					error: false,
					messageError: '',
				});
			} else {
				if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
					this.props.logOut();
				} else {
					this.setState({
						error: true,
						messageError: ref.data.message,
						isLoading: false,
					})
				}
			}
		})
		.catch( (error) => {
			console.log(error);
			this.setState({
				isLoading: false
			});
			this.setState({
				error: true,
				messageError: 'Lấy dữ liệu thất bại',
			})
		})
	}


	checkNotification = () => {
		if ( this.state.isNotification ) {
			return (
				<Alert color="success">{ this.state.textNotification } </Alert>
				);
		}
	}

	change = (e) => {
		this.setState({
			[e.target.name]: e.target.value
		})
	}

	saveSystemEmail = (e) => {
		e.preventDefault();

		this.setState({
			isLoading: true,
			isNotification: '',
			textNotification: '',
			disableButtonSave: true,
		});

		let formData = new FormData();
		let data = { title: this.state.title, subject: this.state.subject, content: this.state.content, service: this.state.service, id: this.state.id };
		for (let [key, val] of Object.entries(data)) {
		  formData.append(key, val);
		}

		let dataAuth = {
			username: process.env.REACT_APP_CLIENT_ID,
			password: process.env.REACT_APP_CLIENT_PASSWD,
			token: process.env.REACT_APP_KEY,
		};

		let config = {
		  	headers: {
				'Content-Type': 'application/json',
				'Authorization' : this.props.token,
				'dataAgency' : JSON.stringify(dataAuth)
			}
		}

		axios.post( process.env.REACT_APP_API_URL + '/api/admin/email/system-email/update', formData, config)
		.then( (ref) => {
			// console.log(ref.data);
			this.setState({
				isLoading: true,
				error: false,
				messageError: '',
				disableButtonSave: false,
			});
			if ( ref.data.error === 0 ) {
				this.setState({
					isNotification: true,
					textNotification: ref.data.message
				});
				this.systemEmailDetail(this.state.id);
			} else {
				if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
					this.props.logOut();
				} else {
					this.setState({
						error: true,
						messageError: ref.data.message,
					})
				}
			}
		})
		.catch( (error) => {
			console.log(error);
			this.setState({
				isLoading: false
			});
			this.setState({
				error: true,
				messageError: 'Lấy dữ liệu thất bại',
			})
		})

	}

	loadForm = () => {
		return (
			<Form onSubmit={ this.saveSystemEmail }>
				<Row>
					<Col xl={8} lg={7} md={12}>
						<Card>
							<CardBody>
								<FormGroup>
									<Label for="title">Tên email</Label>
									<Input
										type="text"
										id="title"
										name="title"
										placeholder="Nhập tiêu đề"
										defaultValue={this.state.title}
										onChange={  this.change }
									/>
								</FormGroup>
								<FormGroup>
									<Label for="subject">Tiêu đề email</Label>
									<Input
										type="text"
										id="subject"
										name="subject"
										placeholder="Subject"
										defaultValue={this.state.subject}
										onChange={ this.change }
									/>
								</FormGroup>
								<FormGroup>
				                  	<Label for="content">Nội dung email</Label>
				                  	<CKEditor
				                  		id="content"
				                  		name="content"
				                  		config={{
				                  			placeholder: "Nhập nội dung email ..."
				                  		}} 
					                    editor={ ClassicEditor }
					                    data={ this.state.content }
					                    onChange={ ( event, editor ) => {
					                        const data = editor.getData();
					                        this.setState({
					                        	content: data
					                        })
					                    } }
					                />
				                </FormGroup>
							</CardBody>
						</Card>
					</Col>
					<Col xl={4} lg={5} sm={12}>
						<Card>
							<CardBody>
									<FormGroup>
										<Label for="title">Loại email</Label>
										<Input 
											className="mb-2" 
											type="select"
											name="service"
											value={ this.state.service }
											onChange={ this.change }
										>
											<option value={''} disabled>Chọn loại email</option>
						                  	{
						                    	this.state.service_type ? 
						                    	Object.entries(this.state.service_type)
											  	.map(
											   		([key, type]) => (<option key={key} value={key}>{type}</option>)
											  	) :
											  	<></>
											}
						                </Input>
									</FormGroup>
									<Button className="btn-sm" type="submit">Cập nhập</Button>
							</CardBody>
						</Card>
					</Col>
				</Row>
			</Form>
		)
	}

	render() {
		return (
			<>
				<Breadcrumb title={"Edit System Email"} page={"Edit System Email"} icon={<MdEmail className="breadcrumb-icon" />} />
				<Row style={{ marginTop: 20 }}>
					<Col sm={12}>
						{ this.state.error ? (<Alert color="danger"><div className='text-center'>{ this.state.messageError }</div></Alert>) : (<></>)}
						{this.checkNotification()}
					</Col>
					<Col sm={12}>
						<Link 
							className={`btn btn-primary btn-sm mb-3`}
							to={'/admin/system-email/create' }

						>
							<MdCreate /> Thêm Email
						</Link>
					</Col>
					
				</Row>
				{
					this.state.isLoading ? (
						<div className="text-center">
			     			<Spinner animation="grow" variant="primary" />
			                <Spinner animation="grow" variant="secondary" />
			                <Spinner animation="grow" variant="success" />
			                <Spinner animation="grow" variant="danger" />
			                <Spinner animation="grow" variant="warning" />
			                <Spinner animation="grow" variant="info" />
			            </div>
					) : (
						<>
							{ this.loadForm() }
						</>
					)
				}
				
				<SystemEmailTips />
			</>	
		)
	}
}

const mapStateToProps = (state) => {
	return {
		token: state.login.token,
		isNotification: state.adminMain.isNotification,
		textNotification: state.adminMain.textNotification,
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		logOut: () => {
			dispatch(({ type : 'logOut', page: 'AdminSystemEmailDetail' }))
		},
		notification: (item) => {
			dispatch(({ type : 'notification', item }))
		},
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(SystemEmailDetailComponent);